import HyCollection from './base/Collection'
import ItemCollection from './ItemCollection'

export default class UserCollections extends HyCollection {

  override options() {
    return { model: ItemCollection, }
  }

  override actions() {
    return {
      fetch: {
        method: 'GET',
        route: 'collections'
      }
    }
  }
}
